import { render, staticRenderFns } from "./jorItem.vue?vue&type=template&id=5b8b26db&scoped=true&"
import script from "./jorItem.vue?vue&type=script&lang=js&"
export * from "./jorItem.vue?vue&type=script&lang=js&"
import style0 from "./jorItem.vue?vue&type=style&index=0&id=5b8b26db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8b26db",
  null
  
)

export default component.exports